import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

// A screen can put one card in the desktop side rail, under the account card
// (design: "About this seller" on a listing).
const RailContext = createContext<{ extra: ReactNode; setExtra: (node: ReactNode) => void }>({ extra: null, setExtra: () => {} });

export function RailProvider({ children }: { children: ReactNode }) {
  const [extra, setExtra] = useState<ReactNode>(null);
  return <RailContext.Provider value={{ extra, setExtra }}>{children}</RailContext.Provider>;
}

export function RailExtra() {
  return <>{useContext(RailContext).extra}</>;
}

export function useRailExtra(node: ReactNode, key: string) {
  const { setExtra } = useContext(RailContext);
  useEffect(() => {
    setExtra(node);
    return () => setExtra(null);
    // key stands in for node, which changes identity on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setExtra, key]);
}
